/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 */

import { useState } from 'react';

import type { ApplicationSpaceOption } from '../../context/AuthContext';
import type { SupportedLanguage } from '../../utils/language.utils';
import { getApplicationAuthCopy } from './application-auth.copy';
import './WorkspaceChooser.css';

export interface ApplicationSpaceChooserProps {
  spaces: readonly ApplicationSpaceOption[];
  language: SupportedLanguage;
  onSelect: (membershipId: string) => Promise<void>;
}

export function ApplicationSpaceChooser({ spaces, language, onSelect }: ApplicationSpaceChooserProps) {
  const copy = getApplicationAuthCopy(language);
  const [busyMembershipId, setBusyMembershipId] = useState<string | null>(null);
  const [error, setError] = useState('');

  const select = async (membershipId: string) => {
    if (busyMembershipId) return;
    setBusyMembershipId(membershipId);
    setError('');
    try {
      await onSelect(membershipId);
    } catch {
      setError(copy.selectorError);
      setBusyMembershipId(null);
    }
  };

  return (
    <div className="workspace-chooser-backdrop" role="presentation">
      <section
        className="workspace-chooser"
        role="dialog"
        aria-modal="true"
        aria-labelledby="application-space-chooser-title"
        aria-describedby="application-space-chooser-description"
      >
        <header className="workspace-chooser-header">
          <div>
            <h1 id="application-space-chooser-title">{copy.selectorTitle}</h1>
            <p id="application-space-chooser-description">{copy.selectorDescription}</p>
          </div>
          {busyMembershipId ? <span className="workspace-chooser-spinner" aria-hidden="true" /> : null}
        </header>
        {error ? <p className="workspace-chooser-error" role="alert">{error}</p> : null}
        <div className="workspace-chooser-list" aria-live="polite">
          {spaces.length === 0 ? <p className="workspace-chooser-state">{copy.selectorEmpty}</p> : null}
          {spaces.map((space) => {
            const busy = busyMembershipId === space.membershipId;
            const monogram = space.spaceName.trim().slice(0, 1).toLocaleUpperCase(language) || '•';
            return (
              <button
                key={space.membershipId}
                type="button"
                className="workspace-chooser-item"
                disabled={busyMembershipId !== null}
                onClick={() => { void select(space.membershipId); }}
                aria-label={`${copy.selectorChoose}: ${space.spaceName}`}
              >
                <span className="workspace-chooser-monogram" aria-hidden="true">{monogram}</span>
                <span className="workspace-chooser-item-copy">
                  <strong>{space.spaceName}</strong>
                  <span>{copy.selectorRole}: {space.roleCode}</span>
                </span>
                <span className="workspace-chooser-item-status">
                  {busy ? copy.selectorSelecting : copy.selectorChoose}
                </span>
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
}
